import { useEffect, useRef } from "react";

const Hangman = ({ step }) => {
  const canvas = useRef();
  let ctx = null;

  useEffect(() => {
    const canvasEle = canvas.current;
    canvasEle.width = 200;
    canvasEle.height = 300;
    ctx = canvasEle.getContext("2d");

    switch (step) {
      case 6:
        drawLine(100, 200, 130, 230);

      case 5:
        drawLine(100, 200, 70, 230);

      case 4:
        drawLine(100, 120, 130, 150);

      case 3:
        drawLine(100, 120, 70, 150);

      case 2:
        drawLine(100, 100, 100, 200);

      case 1:
        drawCircle(100, 80, 20);

      default:
        drawLine(20, 20, 20, 280);
        drawLine(20, 20, 100, 20);
        drawLine(100, 20, 100, 60);
    }
  }, [step]);

  const drawLine = (x1, y1, x2, y2) => {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    ctx.stroke();
  };

  const drawCircle = (x1, y1, r) => {
    ctx.beginPath();
    ctx.arc(x1, y1, r, 0, 2 * Math.PI);
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.fillStyle = "white";
    ctx.fill();
  };

  return (
    <div className="hangman">
      <canvas ref={canvas}></canvas>
    </div>
  );
};

export default Hangman;
